import React, {Component} from 'react';
import {connect} from 'react-redux';
import FilterBySalary from 'components/organisms/filter-by-salary';
import FilterByPoints from 'components/organisms/filter-by-points';
import ExposureMode from 'components/molecules/exposure-mode';
import UniquePlayersQuantity from 'components/molecules/unique-players-quantity';
import LineupsQuantity from 'components/organisms/lineups-quantity';
import SelectSalaryCap from 'components/organisms/select-salary-cap';
import OptimizeButton from 'components/molecules/optimize-button';
import PrioritizeCompletingLineupsAboveExp from 'components/molecules/prioritize-completing-lineups-above-exp';
import RangeOfOutcomes from 'components/organisms/range-of-outcomes/range-of-outcomes';
import ShowPlayersExposureWhileOptimized from 'components/molecules/show-players-exposure-while-optimized';
import OptimizeOpener from 'components/molecules/optimize-opener';
import FilterByLineGroup from 'components/molecules/filter-by-line-group';
import SinglegameForcedStacking from 'components/organisms/singlegame-forced-stacking';
import PlayerPositionStacking from 'components/organisms/player-position-stacking';
import PlayerGroupingsSwitch from 'components/molecules/player-groupings-switch';
import PlayerCombinationStacking from 'components/organisms/player-combination-stacking';
import ProjectionBoostRule from 'components/organisms/projection-boost-rule';
import UserPointsType from 'components/molecules/user-points-type';

class PlayersDashboardComponent extends Component {
    render() {
        const {sportConfig, playersFilter} = this.props;
        const maxUniquePlayers = sportConfig.getPlayersInTeam() - 1;

        return (
            <div>
                <div className="filters-table">
                    <OptimizeOpener />
                    <div className="filters-top">
                        <div className="filters-top-holder">
                            <FilterBySalary
                                key={`sr-${playersFilter.playersType}`}
                                useDragging={true}
                                mode={playersFilter.playersType}
                            />
                            <FilterByPoints
                                key={`pr-${playersFilter.playersType}`}
                                useDragging={true}
                                mode={playersFilter.playersType}
                            />
                            <SelectSalaryCap useDragging={true} />
                            <LineupsQuantity useDragging={true} />
                        </div>
                        <div className="filters-cell select-cell">
                            <ExposureMode />
                            <UserPointsType />
                            <UniquePlayersQuantity max={maxUniquePlayers} />
                        </div>
                    </div>
                    <div className="filters-bottom">
                        <div className="filters-cell">
                            <FilterByLineGroup />
                        </div>
                        <div className="filters-cell">
                            <PrioritizeCompletingLineupsAboveExp />
                        </div>
                        <div className="filters-cell">
                            <RangeOfOutcomes useDragging={true} config={{sport: 'nhl'}} />
                        </div>
                        <div className="filters-cell">
                            <ShowPlayersExposureWhileOptimized />
                        </div>
                    </div>
                    <OptimizeButton />
                </div>
                <SinglegameForcedStacking />
                <PlayerPositionStacking />
                <PlayerGroupingsSwitch>
                    <PlayerCombinationStacking />
                    <ProjectionBoostRule />
                </PlayerGroupingsSwitch>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {sportConfig} = state;
    const {filters: playersFilter} = state.playersData;

    return {
        sportConfig,
        playersFilter,
    };
}

const PlayersDashboard = connect(mapStatesToProps)(PlayersDashboardComponent);

export {PlayersDashboard};
